import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const usePaged = (list, size = 25) => {
  const [page, setPage] = useState(1);
  const pages = Math.max(1, Math.ceil(list.length / size));
  useEffect(() => { if (page > pages) setPage(pages); }, [page, pages]);
  const p = Math.min(page, pages);
  return { items: list.slice((p - 1) * size, p * size), page: p, pages, setPage, total: list.length, size };
};

export const Paginator = ({ pg, testId = "paginator" }) => {
  if (pg.pages <= 1) return null;
  const from = (pg.page - 1) * pg.size + 1;
  const to = Math.min(pg.total, pg.page * pg.size);
  const btn = "rounded-md border border-slate-700 p-1.5 text-slate-300 transition-colors hover:bg-slate-800 disabled:opacity-40 disabled:hover:bg-transparent";
  return (
    <div className="flex items-center justify-end gap-3 border-t border-slate-800 px-4 py-2.5 text-xs text-slate-400" data-testid={testId}>
      <span data-testid={`${testId}-info`}>{from}–{to} de {pg.total}</span>
      <button className={btn} disabled={pg.page <= 1} onClick={() => pg.setPage(pg.page - 1)} data-testid={`${testId}-prev`}><ChevronLeft className="h-4 w-4" /></button>
      <span className="font-mono text-slate-300">{pg.page}/{pg.pages}</span>
      <button className={btn} disabled={pg.page >= pg.pages} onClick={() => pg.setPage(pg.page + 1)} data-testid={`${testId}-next`}><ChevronRight className="h-4 w-4" /></button>
    </div>
  );
};
